<!-- Module Lazy loader -->
<ng-container *ngIf="moduleId" [appLazyDirective]="lazyModuleConfig" [inputs]="inputs" [outputs]="outputs"></ng-container>